var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgXls(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31 9.93657V32.278C31 33.7589 29.7955 34.9592 28.3103 34.9592H7.68967C6.20396 34.9592 5 33.7589 5 32.278V3.68118C5 2.20025 6.20396 1 7.68967 1H22.0343L31 9.93657Z",
    fill: "#79AC00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.7744 20.9966C21.517 20.9966 21.3228 21.0406 21.1912 21.1287C21.0596 21.2168 20.9938 21.3293 20.9938 21.4667C20.9938 21.5983 21.0533 21.7028 21.1721 21.7814C21.291 21.8599 21.5255 21.9422 21.8752 22.0286C22.4498 22.1693 22.86 22.3093 23.1057 22.4484C23.3513 22.5879 23.5376 22.7604 23.6644 22.9668C23.7912 23.1732 23.8544 23.4268 23.8544 23.7277C23.8544 24.0604 23.77 24.3453 23.6018 24.582C23.433 24.8191 23.1937 24.9995 22.8839 25.1242C22.574 25.2495 22.2201 25.3115 21.8221 25.3115C20.7662 25.3115 20.0472 25.0186 19.6652 24.4334L20.5895 23.7855C20.7402 23.9903 20.9148 24.1267 21.1122 24.1957C21.3095 24.2646 21.5207 24.2991 21.7452 24.2991C22.3357 24.2991 22.6313 24.1277 22.6313 23.7855C22.6313 23.6348 22.548 23.5191 22.3808 23.4374C22.2137 23.3557 21.9521 23.2719 21.5961 23.1854C20.9248 23.0384 20.4531 22.8299 20.1804 22.5614C19.9071 22.2924 19.7708 21.9437 19.7708 21.515C19.7708 21.0704 19.9416 20.7037 20.2839 20.4156C20.6256 20.128 21.1286 19.9837 21.7935 19.9837C22.2461 19.9837 22.6451 20.0558 22.99 20.1996C23.3349 20.344 23.6007 20.5599 23.787 20.8475L22.8579 21.5055C22.6361 21.1664 22.2747 20.9966 21.7744 20.9966ZM17.3533 18.0156H18.596V25.163H17.3533V18.0156ZM15.0372 25.163L14.0359 23.5595L12.9858 25.163H11.6089L13.3519 22.6765L11.6375 20.128H13.0872L14.0932 21.7214L15.129 20.128H16.5011L14.7628 22.6091L16.5107 25.163H15.0372Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.9999 9.4362V10.5484H23.6706C22.153 10.5484 21.4531 9.31735 21.4531 7.79926V1H22.5632L30.9999 9.4362Z",
    fill: "#B4E441"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXls);
export default __webpack_public_path__ + "static/media/_xls.2ca31101391ff17b1ea9aba13e02b232.svg";
export { ForwardRef as ReactComponent };